import React from 'react'
import { WifiOff } from 'lucide-react'
import useRoomStore from '../stores/roomStore'

const ConnectionStatus = ({ className = '' }) => {
  const { connectionStatus, isConnected } = useRoomStore()
  const isConnecting = connectionStatus === 'connecting' || connectionStatus === 'reconnecting'

  if (isConnected || isConnecting) return null

  return (
    <div
      role="status"
      className={`inline-flex items-center gap-2 rounded-full border border-red-300/25 bg-red-500/20 px-3 py-2 text-sm font-medium text-red-50 backdrop-blur-sm ${className}`}
    >
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      <span>Server connection lost</span>
    </div>
  )
}

export default ConnectionStatus
